import React from 'react';
import { motion } from 'framer-motion';
export const Letter: React.FC = () => {
  return <section className="py-24 px-6 bg-cream-dark relative" data-id="element-115">
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-24 h-px bg-gold" data-id="element-116"></div>

      <div className="max-w-3xl mx-auto" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-cream p-8 md:p-16 shadow-sm border border-rose-light/30 relative" data-id="element-118">
          <div className="absolute top-4 left-4 w-1.5 h-1.5 rounded-full bg-rose" data-id="element-119"></div>
          <div className="absolute top-4 right-4 w-1.5 h-1.5 rounded-full bg-rose" data-id="element-120"></div>
          <div className="absolute bottom-4 left-4 w-1.5 h-1.5 rounded-full bg-rose" data-id="element-121"></div>
          <div className="absolute bottom-4 right-4 w-1.5 h-1.5 rounded-full bg-rose" data-id="element-122"></div>

          <h2 className="text-2xl mb-8 text-charcoal" data-id="element-123">Hola,</h2>

          <div className="space-y-6 text-charcoal-light text-lg leading-relaxed font-light" data-id="element-124">
            <p data-id="element-125">
              Te escribo esta carta porque sé quién eres. Eres la mujer que
              resuelve. La que siempre tiene un plan. La que construyó su propia
              estabilidad mientras otros esperaban que alguien viniese a
              dársela.
            </p>
            <p data-id="element-126">
              Eres independiente, inteligente y tienes una vida que te ha
              costado mucho esfuerzo levantar. Y precisamente por eso, el amor
              se ha vuelto un terreno confuso para ti.
            </p>
            <p data-id="element-127">
              Seguramente te ha pasado: atraes a hombres que admiran tu brillo,
              pero que después intentan apagarlo. Hombres que se sienten
              intimidados por tu éxito. O peor aún, hombres que llegan a tu vida
              buscando una madre, una jefa o un banco, en lugar de una pareja.
            </p>

            <div className="my-12 py-8 border-y border-rose-light/50 text-center space-y-6" data-id="element-128">
              <p className="text-xl md:text-2xl font-serif text-charcoal italic" data-id="element-129">
                "¿Será que tengo que ser 'menos' para que alguien me quiera?"
              </p>
              <p className="text-xl md:text-2xl font-serif text-charcoal italic" data-id="element-130">
                "¿Será que mi fuerza asusta a los hombres buenos?"
              </p>
              <p className="text-xl md:text-2xl font-serif text-charcoal italic" data-id="element-131">
                "¿O es que simplemente ya no hay hombres a mi altura?"
              </p>
            </div>

            <p className="font-bold text-charcoal" data-id="element-132">
              Déjame decirte algo importante:
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};